<template>
  <List v-if="viewType === 'list'" />
  <Editor v-else-if="viewType === 'new' || viewType === 'edit'" />
</template>

<script setup>
import { watch, ref } from "vue";
import { useRoute } from "vue-router";
import List from "./Activities/List.vue";
import Editor from "./Activities/Editor.vue";

const route = useRoute();

const viewType = ref("");
watch(
  () => route.query?.action,
  /**
   * @param {string?} action
   */
  (action) => {
    if (action === undefined) {
      viewType.value = "list";
    } else {
      viewType.value = action;
    }
  },
  { immediate: true }
);
</script>
